import horizontalScroller from "./horizontalScroller";

const els = document.querySelectorAll('.js-horizontal-scroller');

for (let el of els) {
    horizontalScroller(el);
}
